import { render, staticRenderFns } from "./ModalPropertyValues.vue?vue&type=template&id=31198450&"
import script from "./ModalPropertyValues.vue?vue&type=script&lang=js&"
export * from "./ModalPropertyValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports